import { render, staticRenderFns } from "./AutoTagToggle.vue?vue&type=template&id=3cdd35ea"
import script from "./AutoTagToggle.vue?vue&type=script&lang=js"
export * from "./AutoTagToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports